var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('h1',{staticClass:"display-1"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('v-card-text',[_c('va-list',[_c('va-data-table',{attrs:{"fields":_vm.fields}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }